import React from 'react'
import { Modal } from 'react-bootstrap'

function DocxModal({ show, handleClose }) {
  return (
    <Modal className='modal-main' show={show} onHide={handleClose} centered size='xl'>
      <Modal.Body>
        <Modal.Title>
          <div className="row justify-content-center">
            <div className="col-11 col-8 position-relative">
              <h2>Docx Upload Info</h2>
            </div>
          </div>
        </Modal.Title>
        <div className='my-4'>
          <img src="/images/gif/docx_info.gif" className='img-fluid' alt="" />
        </div>
        <div className='text-center'>
          <button className='cancel-btn w-auto px-5' onClick={handleClose} type='button'>Cancel</button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DocxModal